import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const ActiveOperations = () => (
  <Box sx={{ backgroundColor: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <Typography variant="h1" color="white">banco-de-chile - /app/sales/ordering/active</Typography>
  </Box>
);

export default ActiveOperations;
